/**
 * Profile tab for UserSettingsModal — read-only display of the current
 * user's name, email, role, and default location.
 */

import React from 'react';
import type { Location } from '../../../config/firebase';

interface ProfileTabProps {
  displayName: string;
  email: string;
  role: string;
  defaultLocation?: string;
  locations: Location[];
}

export const ProfileTab: React.FC<ProfileTabProps> = ({
  displayName,
  email,
  role,
  defaultLocation,
  locations,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-bold text-ink mb-2">My Profile</h3>
        <div className="bg-surface border border-line rounded-lg p-4 sm:p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            <div>
              <label className="block text-sm font-medium text-ink-muted mb-1">
                Display Name
              </label>
              <div className="text-ink font-medium text-base sm:text-lg">
                {displayName}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-ink-muted mb-1">
                Email Address
              </label>
              <div className="text-ink font-medium text-sm sm:text-base break-all">
                {email}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-ink-muted mb-1">Role</label>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-info-soft text-info-strong capitalize">
                {role}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-ink-muted mb-1">
                Default Location
              </label>
              <div className="text-ink">
                {locations.find((l) => l.id === defaultLocation)?.name || 'None'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
